import { Card, View, useThemeProvider } from "@towersystems/roam-common-native";
import { StyleSheet } from "react-native";

export interface MediaCardProps {
  titleMarkup: React.ReactNode;
  children: React.ReactNode;
}

export function MediaCard({ titleMarkup, children }: MediaCardProps) {
  const { spacings } = useThemeProvider();

  return (
    <Card containerStyle={styles.cardContainer} style={styles.card}>
      <View style={[styles.cardTitleContainer, { paddingBottom: spacings.s3 }]}>
        {titleMarkup}
      </View>
      {children}
    </Card>
  );
}

const styles = StyleSheet.create({
  cardContainer: {
    maxHeight: "100%",
  },
  card: {
    display: "flex",
    maxHeight: "100%",
    flexShrink: 1,
  },
  cardTitleContainer: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
  },
});
